import { render } from "./Nav.vue?vue&type=template&id=bdd8de32&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=bdd8de32&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bdd8de32"

export default script